<template>
    <div v-if="active" class="card">        
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <Error ref="error" />
        <div class="card-body">
            <PageHeader :title="title" variant="small" class="mb-4" />
            <h3>{{screenData.text.deliveryTitle}}</h3>
            <p>{{screenData.text.deliveryText}}</p>
            <h4 id="security-code-delievry">{{screenData.text.methodTitle}}</h4>
            <p v-html="screenData.text.methodText"></p>
            <div class="col-12 p-0 mt-3 mb-4">
                <div class="form-check my-2" v-for="(method, index) in methods" role="radiogroup" aria-labelledby="security-code-delievry">
                    <input :id="method.id" type="radio" :disabled="isOnlyOne ? 'disabled' : null" name="method" class="form-check-input" :method="method.factorType" :value="method._links.sendCode.href" @change="changeMethod" :checked="isOnlyOne" />
                    <label v-if="method.factorType === '1'" :for="method.id" class="form-check-label">{{screenData.text.phone}}: {{method.factorValue}}</label>
                    <label v-else :for="method.id" class="form-check-label">{{screenData.text.email}}: {{method.factorValue}}</label>
                </div>
            </div>
            <ActionList :actions="screenData.actions" @send-code="sendCode" @send-code-cancel="cancel" />
            <div v-if="sendMethod === '1'" class="mt-5 col-12 px-0">
                <p class="fine-print mb-0">{{screenData.text.smsFrom}}</p>
                <p class="fine-print mb-0">{{screenData.text.smsDisclaimer}} {{screenData.text.oneMessageOnly}}</p>
                <p class="fine-print">{{screenData.text.terms}} <a href="getoobTnC.html" target="_blank" class="theme-primary">{{screenData.text.clickHere}}</a>.</p>
            </div>
            <div v-else class="mt-5 col-12 px-0">
                <p class="fine-print">{{screenData.text.oneMessageOnly}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { nextTick } from 'vue'
    import Error from '../entities/Error.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';

    export default {
        name: "MultiFactorSelect",

        components: {
            Error,
            ActionList,
            PageHeader
        },

        props: {
            screenData: Object
        },

        data: function() {
            return {
                methods: [],
                active: false,
                flow: "",
                sendCodeUrl: "",
                stateToken: "",
                cancelUrl: "",
                allowSendCode: false,
                isOnlyOne: false,
                sendMethod: "",
                securityProfileRiskAuditEnabled: RESOURSE_PROPERTIES.securityProfileRiskAuditEnabled,
            }
        },

        methods: {
            show: function(data) {
                if (data.methods !== undefined) {
                    this.methods = data.methods;
                }

                if (this.methods.length === 1) {                    
                    this.sendCodeUrl = this.methods[0]._links.sendCode.href;
                    this.sendMethod = this.methods[0].factorType;
                    this.allowSendCode = true;
                    this.isOnlyOne = true;
                }

                this.flow = data.flow;
                this.stateToken = data.stateToken;
                this.cancelUrl = data.cancelUrl;
                this.active = true;
                nextTick(function(){
                    if (!this.allowSendCode) {
                        this.$emitter.emit('disable','send-code');
                    }
                }.bind(this));
            },

            hide: function() {
                this.active = false;
                this.allowSendCode = false;
                this.isOnlyOne = false;
                this.sendCodeUrl = "";
                this.sendMethod = "";
            },

            changeMethod: function(e) {
                this.sendCodeUrl = e.target.value;
                this.sendMethod = e.target.attributes.method.value;
                this.allowSendCode = true;
                this.$emitter.emit('enable','send-code');
            },

            sendCode: function() {
                    if (this.allowSendCode) {
                    this.$refs["error"].clear();
                    this.$emitter.emit('start-loading','send-code');
                    var data = {
                        "stateToken": this.stateToken
                    };

                    this.$axios.post(this.sendCodeUrl, data).then(function(response) {
                        if (response.data.success) {
                            var data = {
                                flow: this.flow,
                                stateToken: response.data.data.stateToken,
                                verifyTokenUrl: response.data.data._links.next.href,
                                resendTokenUrl: "",
                                cancelUrl: response.data.data._links.cancel.href,
                                timeRemaining: response.data.data._links.next.timeRemainInSeconds,
                                hideChangeDeliveryMethod: this.isOnlyOne
                            };

                            if (response.data.data._links.resend !== undefined) {
                                data.resendTokenUrl = response.data.data._links.resend.href;
                            }

                            this.$emitter.emit('stop-loading','send-code');
                            this.$emitter.emit('navigate', { componentName: 'mfaVerify', routeData: data});
                        }
                        else {
                            var err = response.data.messages[0];
                            if (err.errorCode === "1526") {
                                if (response.data.data.status === "PII_CHALLENGE") {
                                    var data = {
                                        flow: this.flow,
                                        stateToken: response.data.data.stateToken,
                                        tinType: response.data.data._embedded.factors[0].policy.complexity.tinType,
                                        accountRequired: response.data.data._embedded.factors[0].policy.complexity.accountRequired,
                                        dateOfBirthRequired: response.data.data._embedded.factors[0].policy.complexity.dateOfBirthRequired,
                                        init: false,
                                        validateAPI: response.data.data._embedded.factors[0]._links.validatePii.href,
                                        nextStep: this.screenData.text.loginNextStep,
                                        skipCollection: false,
                                        skipMfaEnrollment: response.data.data._embedded.factors[0].policy.complexity.skipMfaEnrollment,
                                        error: err
                                    };

                                    this.$emitter.emit('navigate', { componentName: 'challengePII', routeData: data});
                                }
                                else if (response.data.data.status === "RETRIEVE_USER") {
                                    var nextScreenData = {
                                        userId: response.data.data.userId,
                                        links: response.data.data._links,
                                        error: err
                                    };

                                    this.$emitter.emit('navigate', { componentName: "retrieveUser", routeData: nextScreenData});
                                }
                                else if (response.data.data.status === "PASSWORD_RESET") {
                                    var resetPasswordData = {
                                        stateToken: response.data.data.stateToken,
                                        api: response.data.data._links.next.next.href,
                                        error: err
                                    };

                                    this.$emitter.emit('navigate', { componentName: "resetPassword", routeData: resetPasswordData});
                                }
                                else if (response.data.data.status === "SUCCESS") {
                                    var data = {
                                        flow: this.flow,
                                        links: response.data.data._links,
                                        noBSL: false
                                    };
                                    this.$emitter.emit('navigate', { componentName: 'skipMfa', routeData: data});
                                }
                                this.$emitter.emit('stop-loading','send-code');
                            }
                        }
                    }.bind(this)).catch(function(error) {
                        if (error.response.data.messages.length > 0) {
                            var err = error.response.data.messages[0];
                            this.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                            this.$emitter.emit('stop-loading','send-code');
                        }
                    }.bind(this));
                }
             },

            cancel: function() {
                this.$emitter.emit('start-loading','send-code-cancel');
                window.location.href = window.location.href;
            }
        },
        computed: {
            title: function(){
                return this.flow + ": " + this.screenData.text.cardTitle
            }
        },

        inject: [
            'getClient'
        ]
    }
</script>
<style scoped>
  .btn:focus{
    box-shadow: 0 0 0 0.2rem rgba(0, 10, 210, 1)
  }
</style>
